export const tr = {
    'agency-login': 'Ajans',
    'build-date': 'Rapor oluşturma tarihi',
    download: 'Raporu indir',
    'end-date': 'Bitiş tarihi',
    id: 'ID',
    link: 'Raporu indir',
    'report-kind': 'Rapor türü',
    'start-date': 'Başlama tarihi',
    status: 'Durum'
};
